'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../../utils/isType/isType.js');
var styles_themeUtils = require('../../styles/themeUtils.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var JumpToContentWrapper = styled__default['default'].a.withConfig({
  displayName: "JumpToContentWrapper",
  componentId: "mo5uar-0"
})(["color:", ";background-color:", ";position:fixed;z-index:999;padding:1.5rem;left:1rem;top:1rem;pointer-events:none;opacity:0;&:focus{opacity:1;}&:hover{text-decoration:underline;z-index:", ";}"], styles_themeUtils.nuDSColor('black'), styles_themeUtils.nuDSColor('success', 'light'), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.zIndexes.jumpToContent);
});
JumpToContentWrapper.displayName = 'JumpToContentWrapper';

var JumpToContent = function JumpToContent(_ref) {
  var href = _ref.href,
      children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement(JumpToContentWrapper, {
    href: href
  }, children);
};

JumpToContent.propTypes = {
  children: index.propTypes.node.isRequired,
  href: index.propTypes.string.isRequired
};

exports.default = JumpToContent;
//# sourceMappingURL=JumpToContent.js.map
